const MOBILE_WIDTH_BREAKPOINT = 768;

export { MOBILE_WIDTH_BREAKPOINT };
